
export interface IErrorLogResponse {
    code: string;
    message: string;
    errors: IErrorDataResponse[];
    route: string;
    url: string;
    user: string;
}

export interface IErrorDataResponse {
    code?: string;
    errorMessage?: string;
    translatedErrorMessage?: string;
}

export const is502Error = (error: any): boolean => {
    return (error?.status === 0 || error?.status === 502) && (error?.name === 'TimeoutError' || error?.name === 'HttpErrorResponse');
};